import { Component, OnInit } from '@angular/core';
import { JobService } from 'src/app/services/job.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-job-detail',
  templateUrl: './job-detail.component.html',
  styleUrls: ['./job-detail.component.scss']
})
export class JobDetailComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  constructor(private _JobDetailService: JobService, private router: Router, private route: ActivatedRoute) { }

  // google map
  lat: number = 13.7466089
  lng: number = 100.5318359
  private sub: any;
  id: any
  info: any
  list: any
  jobid: string
  details_work: string
  positionname: string
  special: string
  isUl: boolean
  isSpecial: boolean

  flag: any

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.sub = this.route.queryParams.subscribe(params => {
      this.jobid = params['jobid'] || 0;
    });

    this._JobDetailService.getJobDetail(this.jobid).subscribe(result => {
      this.list = result;
      if (this.flag == 'th') {
        this.positionname = result['positionname']
        this.details_work = result['details_work']
        this.special = result['special']
      } else {
        this.positionname = result['positionname_en']
        this.details_work = result['details_work_en']
        this.special = result['special_en']
      }

      if (this.details_work.includes('<ul>')){
        this.isUl = true
      } else {
        this.isUl = false
      }
      if (this.special.includes('<ul>')){
        this.isSpecial = true
      } else {
        this.isSpecial = false
      }

      this.id = result['id']
    })
  }

  Detail(id) {
    this.setjob();
    this.router.navigate(['/job-apply'], { queryParams: { jobid: id, } });
  }
  setjob() {

    let v = localStorage.getItem('jobid');

    if (this.id == v) {
    } else {
      localStorage.setItem("jobid", this.id);
    }
  }
}